<template>
  <el-select ref="Select" :value="innerName" style="width: 100%" :filterable="filterable" :disabled="disabled" :filter-method="filterMethod" :placeholder="placeholder">
    <div slot="empty">
      <div style="margin:5px 0" v-if="filterOptions && filterOptions.length > 0">
        <el-row>
          <el-col :span="5" v-for="(item, index) in filterOptions" :key="index">
            <el-input :ref="'queryInput'+ index" v-model="query[item.key]" style="width:100%" :placeholder="item.desc" @keyup.enter.native="querySubmit"></el-input>
          </el-col>
          <!-- <el-col :span="8"> -->
          <el-button class="btn primary" style="min-width:60px" size="small" v-preventReClick @click="querySubmit">查询</el-button>
          <el-button class="btn default" style="min-width:60px" size="small" v-preventReClick @click="reset">重置</el-button>
          <!-- </el-col> -->
        </el-row>
      </div>
      <el-table :data="dataList" border :row-class-name="tableRowClassName" @cell-click="cellClick" max-height="400px" style="max-width:1100px" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template v-for="(item) in columns">
          <el-table-column v-if="item.type=='date'" show-overflow-tooltip :prop="item.key" :min-width="item.width || 120" :label="item.label" :key="item.label">
            <template slot-scope="scope">
              {{scope.row[item.key] ? parseTime(new Date(scope.row[item.key]), "{y}-{m}-{d}") : ''}}
            </template>
          </el-table-column>
          <el-table-column v-else-if="item.type=='datetime'" show-overflow-tooltip :prop="item.key" :min-width="item.width || 120" :label="item.label" :key="item.label">
            <template slot-scope="scope">
              {{scope.row[item.key] ? parseTime(new Date(scope.row[item.key])) : ''}}
            </template>
          </el-table-column>
          <el-table-column v-else-if="item.type=='longTime'" show-overflow-tooltip :prop="item.key" :min-width="item.width || 120" :label="item.label" :key="item.label">
            <template slot-scope="scope">
              {{ scope.row.longTime == 1 ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column v-else-if="item.key=='productName'" show-overflow-tooltip :prop="item.key" :min-width="item.width || 120"  :key="item.label"  :label="item.label">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isTempPurchase == 1 &&$route.name == 'PurchasePlanEdit'"  size="mini">临</el-tag>
              {{scope.row.productName}}
            </template>
          </el-table-column>
          <el-table-column v-else show-overflow-tooltip :prop="item.key" :min-width="item.width || 120" :label="item.label" :key="item.label"></el-table-column>
        </template>
      </el-table>
    </div>
  </el-select>
</template>

<script>

export default {
  name: 'SelectTable',
  props: {
    value: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default () {
        return;
      }
    },
    dataList: {
      type: Array,
      default () {
        return []
      }
    },
    innerName: {
      type: String,
      default () {
        return ''
      }
    },
    placeholder: {
      type: String,
      default () {
        return '请选择'
      }
    },
    filterable: {
      type: Boolean,
      default () {
        return true
      }
    },

    filterOptions: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      query: {}
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  computed: {
  },
  methods: {
    // 样式
    tableRowClassName ({ row, rowIndex }) {
      if (row.id === this.value) {
        return 'select-row';
      }
      return '';
    },
    cellClick (row, column, cell, event) {
      this.$emit('change', row);
      this.$refs.Select.blur();
    },
    filterMethod (val) {
      this.$emit("filterMethod", val);
    },
    querySubmit () {
      this.$emit("querySubmit", this.query);
    },
    reset () {
      this.query = {}
      this.$emit("querySubmit", this.query);
    }
  }
}
</script>

<style lang="scss" scoped>
.el-table .select-row {
  background: #f0f9eb;
}
div /deep/.el-table__body-wrapper {
  max-height: 348px !important;
}
/deep/ .el-table__header-wrapper {
  height: 100% !important;
}
</style>
